import { render, staticRenderFns } from "./PolizaMascotas.vue?vue&type=template&id=2320dad1&scoped=true&"
import script from "./PolizaMascotas.vue?vue&type=script&lang=js&"
export * from "./PolizaMascotas.vue?vue&type=script&lang=js&"
import style0 from "./PolizaMascotas.vue?vue&type=style&index=0&id=2320dad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320dad1",
  null
  
)

export default component.exports